import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const usePipeCreate = () => {
  const qc = useQueryClient();

  return useMutation(
    async (
      data: {
        name: string;
        orders: number;
        id?: number;
      }[]
    ) => {
      const res = await $api.post('/v1/pipe/create', data);

      return res?.data?.data;
    },
    {
      onSuccess: () => {
        qc.invalidateQueries([crmConstants.queryKeys.PIPE_ALL]);
        qc.invalidateQueries([crmConstants.queryKeys.LEAD_FILTER_PARAMS]);
      }
    }
  );
};
